import Phaser from 'phaser';

export interface ZenPileOpts {
  scene: Phaser.Scene;
  id: number;
  x: number;
  y: number;
  amount: number;
  ownerUid?: string;
  ownerUntil?: number;
}

export class ZenPile extends Phaser.GameObjects.Container {
  pileId: number;
  amount: number;
  ownerUid?: string;
  ownerUntil?: number;
  private coin!: Phaser.GameObjects.Graphics;
  private label!: Phaser.GameObjects.Text;
  private bobTween?: Phaser.Tweens.Tween;
  alive = true;

  constructor(opts: ZenPileOpts) {
    super(opts.scene, opts.x, opts.y);
    this.pileId = opts.id;
    this.amount = opts.amount;
    this.ownerUid = opts.ownerUid;
    this.ownerUntil = opts.ownerUntil;

    this.coin = opts.scene.add.graphics();
    this.drawCoin();

    this.label = opts.scene.add.text(0, -22, `${opts.amount} Zen`, {
      fontFamily: '"Philosopher", "Cinzel", serif', fontSize: '11px', color: '#ffeb3b',
      stroke: '#000', strokeThickness: 3,
    }).setOrigin(0.5);

    this.add([this.coin, this.label]);
    this.setSize(40, 40);
    this.setInteractive(new Phaser.Geom.Rectangle(-20, -20, 40, 40), Phaser.Geom.Rectangle.Contains);
    this.setDepth(15);
    opts.scene.add.existing(this);

    this.bobTween = opts.scene.tweens.add({
      targets: this.coin,
      y: -4,
      duration: 600,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }

  private drawCoin() {
    this.coin.clear();
    // shadow
    this.coin.fillStyle(0x000000, 0.4);
    this.coin.fillEllipse(0, 6, 18, 6);
    // coin body
    this.coin.fillStyle(0xfbc02d, 1);
    this.coin.fillCircle(0, 0, 9);
    this.coin.lineStyle(1.5, 0xff8f00, 1);
    this.coin.strokeCircle(0, 0, 9);
    // shine
    this.coin.fillStyle(0xffffff, 0.6);
    this.coin.fillCircle(-3, -3, 2);
  }

  fadeOutAndDestroy() {
    if (!this.alive) return;
    this.alive = false;
    this.bobTween?.stop();
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      y: this.y - 16,
      duration: 250,
      onComplete: () => this.destroy(),
    });
  }
}
